/* HEILMANN HOME · Favoritter
   Hjertet paa kortene, "Gem som favorit" paa produktsiden og hjertet i
   headeren var alle doede: markuppen fandtes, men der var ingen JS.

   Noeglen er produktets handle (ikke id), fordi vi bruger den til at hente
   varen igen via Shopifys egen /products/<handle>.js. Saa kommer titel, pris
   og lagerstatus fra butikken — vi gemmer aldrig en kopi, der kan blive
   foraeldet. Listen ligger i localStorage, altsaa paa den enkelte enhed:
   ingen kundekonto kraeves for at gemme en vare. */
(function () {
  var GAEST = 'hh:favoritter';
  /* Er nogen logget ind, hoerer listen til DEM — ikke til browseren. To
     personer paa samme computer ser derfor ikke hinandens favoritter, og
     listen er der igen naeste gang, man logger ind paa samme enhed.

     ⚠️ Det er stadig localStorage. Listen foelger IKKE med til telefonen:
     et tema kan ikke skrive til kundens konto i Shopify — det kraever en app
     med customer_write_customers. Se BUILD-LOG.md. */
  var KUNDE = (document.body.getAttribute('data-hh-kunde') || '').trim();
  var NOEGLE = KUNDE ? GAEST + ':' + KUNDE : GAEST;
  var drawer = document.getElementById('hh-favoritter');

  /* ---------- lager ---------- */
  /* Private vinduer og "bloker cookies" faar localStorage til at KASTE,
     ikke bare returnere null. Uden try/catch doer hele scriptet der. */
  function laes() {
    try {
      var r = JSON.parse(localStorage.getItem(NOEGLE) || '[]');
      return Array.isArray(r) ? r.filter(function (h) { return typeof h === 'string' && h; }) : [];
    } catch (e) { return []; }
  }
  function skriv(liste) {
    try { localStorage.setItem(NOEGLE, JSON.stringify(liste)); } catch (e) {}
  }
  function har(h) { return laes().indexOf(h) !== -1; }
  /* Til favoritsiden (hh-favoritside.js): læs listen og hør om ændringer. */
  window.HHFavoritter = { liste: function () { return laes(); } };

  /* ---------- kontoen (når "Gem favoritter på kundens konto" er slået til) ----------
     Er kunden logget ind, sender serveren listen fra kunde-metafeltet
     custom.favoritter med i <body data-hh-favs-konto>. Kontoen er den gældende
     liste – browseren er kun en hurtig kopi. Ændringer sendes samlet (hele
     listen) til app proxy'en ~0,6 s efter sidste klik. */
  var KONTO_ATTR = document.body.getAttribute('data-hh-favs-konto');
  var PROXY = document.body.getAttribute('data-hh-favs-proxy') || '/apps/hh-favoritter';
  var KONTO = !!(KUNDE && KONTO_ATTR !== null);
  var gemTid = null;

  function kontoListe() {
    try {
      var v = JSON.parse(KONTO_ATTR || '[]');
      if (typeof v === 'string') v = JSON.parse(v || '[]');
      return Array.isArray(v) ? v.filter(function (h) { return typeof h === 'string' && h; }) : [];
    } catch (e) { return []; }
  }

  function gemPaaKonto(straks) {
    if (!KONTO) return;
    clearTimeout(gemTid);
    var send = function () {
      try {
        fetch(PROXY + '/gem', {
          method: 'POST',
          credentials: 'same-origin',
          keepalive: true,
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ handles: laes() })
        }).catch(function () {});
      } catch (e) {}
    };
    if (straks) send(); else gemTid = setTimeout(send, 600);
  }

  /* Gemte man noget, FOER man loggede ind, skal det ikke gaa tabt i login'et. */
  function fletGaesteliste() {
    if (!KUNDE) return;
    if (KONTO) {
      /* Kontoen vinder over browserens kopi (ellers kommer en favorit, der er
         fjernet på telefonen, tilbage fra computerens gamle kopi). Kun en
         gæsteliste fra før login lægges oveni. */
      var konto = kontoListe();
      var g = [];
      try { g = JSON.parse(localStorage.getItem(GAEST) || '[]'); } catch (e) {}
      var nye = Array.isArray(g) ? g.filter(function (h) { return typeof h === 'string' && h && konto.indexOf(h) === -1; }) : [];
      skriv(konto.concat(nye));
      try { localStorage.removeItem(GAEST); } catch (e) {}
      if (nye.length) gemPaaKonto(true);
      return;
    }
    var gaest;
    try { gaest = JSON.parse(localStorage.getItem(GAEST) || '[]'); } catch (e) { return; }
    if (!Array.isArray(gaest) || !gaest.length) return;
    var mine = laes();
    gaest.forEach(function (h) { if (mine.indexOf(h) === -1) mine.push(h); });
    skriv(mine);
    try { localStorage.removeItem(GAEST); } catch (e) {}
  }

  /* ---------- visning ---------- */
  function opdaterTaeller() {
    var n = laes().length;
    document.querySelectorAll('[data-hh-fav-taeller]').forEach(function (el) {
      el.textContent = n;
      el.hidden = n < 1;
    });
  }

  function markerEn(knap) {
    var gemt = har(knap.dataset.hhFav);
    knap.setAttribute('aria-pressed', gemt ? 'true' : 'false');
    /* PDP-knappen er tekst, kortets er et ikon — kun teksten skal skiftes. */
    if (knap.classList.contains('hh-pdp__fav')) {
      knap.textContent = gemt ? '♥ Gemt som favorit' : '♡ Gem som favorit';
    }
    knap.dataset.hhFavKlar = '1';
  }

  function marker(rod) {
    (rod || document).querySelectorAll('[data-hh-fav]').forEach(markerEn);
    opdaterTaeller();
  }

  /* ---------- lille kvittering ---------- */
  var toastEl, toastTid;
  function toast(tekst) {
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'hh-toast';
      toastEl.setAttribute('role', 'status');
      document.body.appendChild(toastEl);
    }
    toastEl.textContent = tekst;
    toastEl.classList.add('er-inde');
    clearTimeout(toastTid);
    toastTid = setTimeout(function () { toastEl.classList.remove('er-inde'); }, 2600);
  }

  /* ---------- slaa til/fra ---------- */
  function skift(handle) {
    var liste = laes();
    var i = liste.indexOf(handle);
    var gemt = i === -1;
    if (gemt) { liste.push(handle); } else { liste.splice(i, 1); }
    skriv(liste);
    gemPaaKonto(false);

    document.querySelectorAll('[data-hh-fav="' + handle.replace(/"/g, '\\"') + '"]').forEach(function (k) {
      markerEn(k);
      if (!k.classList.contains('hh-pdp__fav')) {
        /* genstart animationen: fjern klassen, tving reflow, saet den igen */
        k.classList.remove('er-klikket');
        void k.offsetWidth;
        k.classList.add('er-klikket');
      }
    });
    opdaterTaeller();
    toast(gemt ? 'Gemt i dine favoritter' : 'Fjernet fra favoritter');
    document.dispatchEvent(new CustomEvent('hh:favoritter', { detail: { handle: handle, gemt: gemt } }));
    if (drawer && !drawer.hidden) tegnListe();
  }

  /* Delegeret, fordi filtrene udskifter hele produktgitteret via Section
     Rendering API — listeners paa de enkelte knapper ville forsvinde. */
  document.addEventListener('click', function (e) {
    var k = e.target.closest && e.target.closest('[data-hh-fav]');
    if (!k) return;
    e.preventDefault();
    e.stopPropagation();
    skift(k.dataset.hhFav);
  });

  /* Nye kort fra AJAX-filtrering skal have deres hjerte sat rigtigt.
     Kun knapper uden data-hh-fav-klar roeres, saa det er billigt. */
  function markerNye() {
    document.querySelectorAll('[data-hh-fav]:not([data-hh-fav-klar])').forEach(markerEn);
  }
  /* Filtrene melder selv nyt indhold. Observeren er nettet under de steder,
     der henter markup uden at melde det (fx anbefalinger paa produktsiden). */
  document.addEventListener('hh:nytindhold', markerNye);
  if (window.MutationObserver) {
    var mt;
    new MutationObserver(function () {
      clearTimeout(mt);
      mt = setTimeout(markerNye, 50);
    }).observe(document.body, { childList: true, subtree: true });
  }

  /* ---------- drawer ---------- */
  if (!drawer) { fletGaesteliste(); marker(); return; }

  var overlay = document.querySelector('[data-hh-favs-overlay]');
  var tom = drawer.querySelector('[data-hh-favs-tom]');
  var henterEl = drawer.querySelector('[data-hh-favs-henter]');
  var liste = drawer.querySelector('[data-hh-favs-liste]');
  var note = drawer.querySelector('[data-hh-favs-note]');
  var alleLink = drawer.querySelector('[data-hh-favs-alle]');
  var sidstFokus = null;
  var cache = {};

  function kr(oere) {
    var v = oere / 100;
    return v.toLocaleString('da-DK', {
      minimumFractionDigits: v % 1 ? 2 : 0,
      maximumFractionDigits: 2
    }) + ' kr';
  }

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  /* Samme oprydning som paa kortene (spec pkt. 61) — produktdata roeres ikke. */
  function pentTitel(t) {
    return String(t || '')
      .replace(/^Secondhand\s*[-–]\s*/i, '')
      .replace(/^OUTLET\s*[-–]\s*/i, '');
  }

  function hent(handle) {
    if (cache[handle]) return Promise.resolve(cache[handle]);
    return fetch(window.Shopify && window.Shopify.routes && window.Shopify.routes.root
        ? window.Shopify.routes.root + 'products/' + handle + '.js'
        : '/products/' + handle + '.js')
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (p) { cache[handle] = p; return p; })
      .catch(function () { return null; });
  }

  function raekke(p) {
    var billede = p.featured_image
      ? p.featured_image.replace(/(\.[a-z]+)(\?|$)/i, '_160x$1$2')
      : '';
    var variant = null;
    for (var i = 0; i < p.variants.length; i++) {
      if (p.variants[i].available) { variant = p.variants[i]; break; }
    }
    var enkelt = p.variants.length === 1;

    /* En RIGTIG formular mod /cart/add — saa overtager hh-kurv.js den via sin
       submit-lytter, henter kurv-sektionen igen og aabner kurven. Et eget
       fetch-kald her ville vaere en anden vej ind i kurven, der kunne komme
       ud af trit med den. */
    var handling = variant && enkelt
      ? '<form class="hh-favs__form" action="/cart/add" method="post">'
        + '<input type="hidden" name="id" value="' + variant.id + '">'
        + '<button class="hh-btn hh-btn--lille" type="submit">Læg i kurv</button></form>'
      : variant
        ? '<a class="hh-btn hh-btn--lille" href="' + esc(p.url) + '">Vælg variant</a>'
        : '<span class="hh-meta hh-favs__udsolgt">Udsolgt</span>';

    return '<li class="hh-favs__linje" data-hh-favs-linje="' + esc(p.handle) + '">'
      + '<a class="hh-favs__billede" href="' + esc(p.url) + '" tabindex="-1" aria-hidden="true">'
      + (billede ? '<img src="' + esc(billede) + '" alt="" loading="lazy" decoding="async">' : '')
      + '</a>'
      + '<div class="hh-favs__tekst">'
      + '<a class="hh-favs__navn" href="' + esc(p.url) + '">' + esc(pentTitel(p.title)) + '</a>'
      + '<p class="hh-favs__pris">' + kr(p.price) + '</p>'
      + handling
      + '</div>'
      + '<button class="hh-favs__fjern" type="button" data-hh-favs-fjern="' + esc(p.handle)
      + '" aria-label="Fjern ' + esc(pentTitel(p.title)) + ' fra favoritter">'
      + '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/></svg>'
      + '</button></li>';
  }

  function tegnListe() {
    var handles = laes();
    if (!handles.length) {
      tom.hidden = false;
      liste.hidden = true;
      henterEl.hidden = true;
      if (note) note.hidden = true; if (alleLink) alleLink.hidden = true;
      liste.innerHTML = '';
      return;
    }
    tom.hidden = true;
    if (!liste.innerHTML) henterEl.hidden = false;

    Promise.all(handles.map(hent)).then(function (varer) {
      /* En slettet eller skjult vare giver 404. Den ryger ud af listen, saa
         kunden ikke sidder med en usynlig favorit for evigt. */
      var levende = [];
      var html = '';
      varer.forEach(function (p, i) {
        if (!p) return;
        levende.push(handles[i]);
        html += raekke(p);
      });
      if (levende.length !== handles.length) { skriv(levende); opdaterTaeller(); marker(); gemPaaKonto(false); }
      henterEl.hidden = true;
      if (!levende.length) {
        tom.hidden = false; liste.hidden = true; liste.innerHTML = '';
        if (note) note.hidden = true; if (alleLink) alleLink.hidden = true;
        return;
      }
      liste.innerHTML = html;
      liste.hidden = false;
      if (note) note.hidden = false; if (alleLink) alleLink.hidden = false;
    });
  }

  function aabn() {
    if (drawer.classList.contains('is-aaben')) return;
    sidstFokus = document.activeElement;
    tegnListe();
    drawer.hidden = false;
    if (overlay) overlay.hidden = false;
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        drawer.classList.add('is-aaben');
        if (overlay) overlay.classList.add('is-aaben');
      });
    });
    document.body.style.overflow = 'hidden';
    var luk = drawer.querySelector('[data-hh-favs-luk]');
    if (luk) luk.focus();
  }

  function luk() {
    if (!drawer.classList.contains('is-aaben')) return;
    drawer.classList.remove('is-aaben');
    if (overlay) overlay.classList.remove('is-aaben');
    document.body.style.overflow = '';
    setTimeout(function () {
      if (!drawer.classList.contains('is-aaben')) {
        drawer.hidden = true;
        if (overlay) overlay.hidden = true;
      }
    }, 500);
    if (sidstFokus && sidstFokus.focus) sidstFokus.focus();
  }

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (t.closest && t.closest('[data-hh-aabn-favoritter]')) { e.preventDefault(); aabn(); return; }
    if (t.closest && t.closest('[data-hh-favs-luk]')) { luk(); return; }
    if (overlay && t === overlay) { luk(); return; }

    var fjern = t.closest && t.closest('[data-hh-favs-fjern]');
    if (fjern) { skift(fjern.dataset.hhFavsFjern); return; }
  });

  /* Kurven aabner oven i denne drawer, naar en favorit laegges i kurven —
     saa luk favoritterne foerst, ellers staar to drawers aabne paa samme tid. */
  document.addEventListener('submit', function (e) {
    if (e.target.closest && e.target.closest('.hh-favs__form')) luk();
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && drawer.classList.contains('is-aaben')) luk();
  });

  /* Gemt i en anden fane? Saa skal hjerterne her ogsaa opdateres. */
  window.addEventListener('storage', function (e) {
    if (e.key !== NOEGLE) return;
    document.querySelectorAll('[data-hh-fav]').forEach(markerEn);
    opdaterTaeller();
    if (!drawer.hidden) tegnListe();
  });

  fletGaesteliste();
  marker();
})();
